import React, { Component } from "react";
import "moment-timezone";

import { Panel, Table } from 'react-bootstrap'
import { Link } from "react-router-dom";

import Flags from '../Deals/Flags'
import TCSFlags from '../TCS/Flags'
import SRFlags from '../SeminarRegistrations/Flags'

class RelatedPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    const { deals, followUps } = this.props;

    return (
      <div>
        <Panel bsStyle="success" className='compact-panel'>
          <Panel.Heading>
            <Panel.Title componentClass="h3">
              Related
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body style={{ padding: 10 }}>
            <h4 style={{ marginTop: 0 }}>Deals</h4>
            {deals && deals.length > 0
              ? (<Table bordered condensed hover style={{ fontSize: 13 }}>
                <thead className='dark'>
                  <tr>
                    <th style={{ width: '20%' }}>ID</th>
                    <th>Deal Status</th>
                  </tr>
                </thead>
                <tbody>
                  {deals.map((deal, index) => {
                    return (<tr key={index}>
                      <td><Link to={`/m1/deals/${deal.id}`} style={{ whiteSpace: 'nowrap' }}>Deal #{deal.id}</Link></td>
                      <td>
                        <SRFlags deal={deal} prefix="Registration: " />
                        <TCSFlags deal={deal} prefix='TCS: ' />
                        <Flags deal={deal} prefix='Deal: ' />

                      </td>
                    </tr>)
                  })}
                </tbody>
              </Table>)
              : <div style={{ margin: 10 }}>No related deals</div>}


            <h4 style={{ marginTop: 0 }}>Follow Ups</h4>
            {followUps && followUps.length > 0
              ? (<Table bordered condensed hover style={{ fontSize: 13 }}>
                <thead className='dark'>
                  <tr>
                    <th style={{ width: '20%' }}>ID</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {followUps.map((follow_up, index) => {
                    return (<tr key={index}>
                      <td><Link to={`/m1/follow_ups/${follow_up.id}`} style={{ whiteSpace: 'nowrap' }}>Follow Up #{follow_up.id}</Link></td>
                      <td>
                        {follow_up.lead_type}
                      </td>
                    </tr>)
                  })}
                </tbody>
              </Table>)
              : <div style={{ margin: 10 }}>No related follow ups</div>}

          </Panel.Body>
        </Panel>

      </div>

    );
  }
}
export default RelatedPanel;
